<template lang="pug">
span(:title="fullDate") {{ timeAgo }} at {{ time }}
</template>

<script setup lang="ts">
import { formatTimeAgo } from '@vueuse/core';
import { computed } from 'vue';
const props = defineProps<{ date: number | string | Date }>();

const timeAgo = computed(() => {
  let now = new Date();
  let date = new Date(props.date);

  // same calendar day
  if (+now - +date < 24 * 60 * 60 * 1000 && now.getDate() === date.getDate()) {
    return formatTimeAgo(date);
  }

  // past week
  if (+now - +date < 6.5 * 24 * 60 * 60 * 1000) {
    return date.toLocaleDateString('en-GB', {
      weekday: 'long'
    });
  }

  return date.toLocaleDateString('en-GB', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
});

const time = computed(() => {
  return new Date(props.date).toLocaleTimeString('en-GB', {
    timeStyle: 'short'
  });
});

const fullDate = computed(() => {
  return new Date(props.date).toLocaleDateString('en-GB', {
    dateStyle: 'full'
  });
});
</script>
